export default __webpack_public_path__ + "static/cover-bimp-f23b8b02d99b051b302c664c4373ddff.png";